import { motion } from "framer-motion";

const benefits = [
  {
    title: "Earlier Insights",
    description: "Gain valuable insights into cognitive changes up to 18 months earlier than traditional methods through continuous AI monitoring."
  },
  {
    title: "Personalized Care",
    description: "Tailored interventions and recommendations based on individual cognitive patterns and history."
  },
  {
    title: "Family Peace of Mind",
    description: "Real-time updates and insights provide families with confidence in their loved ones' cognitive health status."
  },
  {
    title: "Healthcare Integration",
    description: "Seamless connection with existing healthcare systems for comprehensive care coordination."
  },
  {
    title: "Data-Driven Insights",
    description: "Advanced analytics provide actionable insights for better care decisions and outcomes."
  },
  {
    title: "Continuous Improvement",
    description: "Self-learning AI systems that evolve and improve with each interaction and data point."
  }
];

export const BenefitsSection = () => {
  return (
    <section className="py-20 sm:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="apple-heading text-3xl sm:text-4xl lg:text-5xl mb-6 tracking-tight">
            Transformative Benefits
          </h2>
          <p className="apple-subheading text-lg sm:text-xl max-w-3xl mx-auto text-[#86868b]">
            Our combined <span className="ai-term">vertical AI</span> and <span className="ai-term">guided-agentic AI</span> approach
            delivers unprecedented advantages in cognitive health care.
          </p>
        </motion.div>

        <div className="grid gap-8 md:grid-cols-3">
          {benefits.map((benefit, index) => (
            <motion.div
              key={benefit.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="bg-[#F5F5F7] rounded-2xl p-6 hover:shadow-lg transition-shadow"
            >
              <h3 className="apple-heading text-xl mb-3">{benefit.title}</h3>
              <p className="apple-subheading text-[#86868b]">{benefit.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};